import React, { useState } from 'react'
import Header from './header'
import { Button } from '@/components/ui/button'
import { Building, Send, ActivityIcon, BarChart2, Boxes, ReceiptTextIcon } from 'lucide-react'
import ReceivedBadge from '@/routes/(inventory)/-module-components/badges/received'
import CustomTabs from '@/components/purchase-order/components/custom_tabs'
import MetricsTab from '@/components/purchase-order/components/metrics_tab'
import StocksTab from '@/components/purchase-order/components/stocks_tab'
import ActivityTab from '@/components/purchase-order/components/activity_tab'
import UpdateStatusDialog from '@/components/purchase-order/components/update-status-dialog'
import { Route as poRoute } from "@/routes/(pharma)/_layout/inventory/purchase-order/$id/index"
import { Level } from '@/gen/auth/common_pb'
import POPDF from '@/components/composable-pdf/po-pdf'
import { pdf } from '@react-pdf/renderer'
import { useRouter } from '@tanstack/react-router'
import { Supplier, SupplierMetadata } from '@/gen/suppliers/common_pb'
const screen = () => {
  const [activeTab, setActiveTab] = useState('Activity')
  const data = poRoute.useLoaderData()
  const params = poRoute.useParams()
  const router = useRouter();
  const TABS = [
      { label: 'Activity', icon: <ActivityIcon className="w-3 h-3" />, count: data.activity.activities.length || 0 },
      { label: 'Metrics', icon: <BarChart2 className="w-3 h-3" /> },
      { label: 'Stocks', count: data.purchaseOrder.purchaseOrders?.items.length, icon: <Boxes className="w-3 h-3" /> },
  ]
  const handleOpenPDF = () => {
    const pdfDoc = <POPDF poData={data.purchaseOrder.purchaseOrders!}/>
    pdf(pdfDoc)
      .toBlob()
      .then((blob) => {
        const url = URL.createObjectURL(blob)
        window.open(url, '_blank')
      })
  }

  const supplierInfo = new Supplier()
  supplierInfo.name = data.purchaseOrder.purchaseOrders?.supplierName || '';
  supplierInfo.metadata = data.purchaseOrder.purchaseOrders?.supplierMetadata || new SupplierMetadata();

  return (
    <div className="h-screen w-full max-w-screen flex flex-col overflow-hidden">
      <Header />
      <hr className='mt-2' />
      <div className="flex items-center justify-between px-2 py-2">
        <div className="flex items-center gap-x-1">
          <span className="text-sm font-medium">{data.purchaseOrder.purchaseOrders?.orderNumber}</span>
          <span className="h-5 w-px bg-border mx-1" />
          <span className="text-sm text-gray-600 underline">Stock Point: {data.purchaseOrder.purchaseOrders?.stockPointName}</span>
        </div>
        <div className="flex items-center gap-2">
          <Button size="sm" variant="outline" onClick={handleOpenPDF}>
            <Send className="w-3 h-3 mr-1"/>Send Order PDF
          </Button>
          {data.purchaseOrder.purchaseOrders?.purchaseInvoiceId !== "00000000-0000-0000-0000-000000000000" && <Button size="sm" variant="outline" onClick={() => {
            router.navigate({
              to: "/inventory/purchase-invoice/$id",
              params: {
                id: data.purchaseOrder.purchaseOrders?.purchaseInvoiceId!
              },
            })
          }}>
            <ReceiptTextIcon className="w-3 h-3 mr-1"/>Open Purchase Invoice
          </Button>}
          {data.purchaseOrder.purchaseOrders?.purchaseInvoiceId === "00000000-0000-0000-0000-000000000000" && <UpdateStatusDialog document_number={data.purchaseOrder.purchaseOrders?.orderNumber!} type='PO' poItems={data.purchaseOrder.purchaseOrders?.items} initialisedFrom={Level.STOCK_POINT} document_id={params.id} supplier_id={data.purchaseOrder.purchaseOrders?.supplierId!}/>}
        </div>
      </div>
      <CustomTabs tabs={TABS} activeTab={activeTab} onTabClick={setActiveTab} />
      <hr className='' />
      <div className="flex-1 min-h-0 pb-24">
        {activeTab === 'Activity' && <ActivityTab activities={data.activity.activities} supplierInfo={supplierInfo} initiatedBy={Level.STOCK_POINT} productCount={data.purchaseOrder.purchaseOrders?.items.length!}/>}
        {activeTab === 'Metrics' && <MetricsTab />}
        {activeTab === 'Stocks' && <StocksTab poItems={data.purchaseOrder.purchaseOrders?.items} supplierInfo={supplierInfo}/>}
      </div>
    </div>
  )
}

export default screen